import { memo } from 'react';
import { cn, RawHtml } from '@divlab/divanui';

import { useRequest } from '@Contexts/Request';
import Img from '@UI/Img';
import ServicePageWrapper from '@Components/ServicePageWrapper';
import styles from './CreditSlimBanner.module.css';

import type { BannerData } from './typings';
import type { FC, HTMLAttributes } from 'react';

export interface CreditSlimBannerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  banner: BannerData;
  cnPrefix?: string;
}

const CreditSlimBanner: FC<CreditSlimBannerProps> = (props) => {
  const { className, banner, cnPrefix, ...restProps } = props;
  const { conditions = [], note, text, logo, color, id, title } = banner;
  const { country } = useRequest();
  const isCompactView = country === 'KAZ';

  return (
    <div {...restProps} className={cn(styles.slimBanner, className)} style={{ background: color }}>
      <ServicePageWrapper>
        <div
          className={cn(styles.container, {
            [styles.kaspi]: id === 'kaspi',
            [styles.homeCredit]: id === 'homeCredit',
            [styles.jusan]: id === 'jusan',
            [styles.bcc]: id === 'bcc',
            [styles.halva]: id === 'halva',
            [styles.halvaPartial]: id === 'halvaPartial',
            [styles.split]: id === 'yandex-split',
            [styles.tinkoff]: id === 'tinkoff',
            [styles.plite]: id === 'halva-partial',
            [styles.directCredit]: id === 'directCredit',
          })}
        >
          <div className={styles.left}>
            <div className={styles.logoContainer}>
              <Img
                alt='banner-logo'
                className={styles.logo}
                cnImage={styles.logoImg}
                src={logo}
                loading='eager'
              />

              {title && <div className={styles.title}>{title}</div>}
            </div>
            <div className={styles.textContainer}>
              {text && <div className={styles.text}>{text}</div>}

              {note && <div className={styles.nuance}>{note}</div>}
            </div>
          </div>

          <div className={cn(styles.right, { [styles.compactView]: isCompactView })}>
            {conditions.map((condition) => {
              return condition.items?.map(({ digit, symbol, prefix }) => {
                // заменяем минусы на тире для корректного отображения в safari
                const safeDigit = digit !== null && digit.toString().replace(/-/g, '–');

                return (
                  <div className={styles.item} key={`${digit}_${symbol}`}>
                    {prefix && <div className={styles.prefix}>{prefix}</div>}
                    <div className={styles.digit}>{safeDigit}</div>
                    {symbol && <RawHtml className={cn(styles.symbol, cnPrefix)} html={symbol} />}
                  </div>
                );
              });
            })}
          </div>
        </div>
      </ServicePageWrapper>
    </div>
  );
};

export default memo(CreditSlimBanner);
